<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { AppBackground } from '@haskoning/vue-component-library'

import AppSideBar from '@/components/app/AppSideBar.vue'
import HardwareProfileManagement from '@/components/hardware-profile/HardwareProfileManagement.vue'
import { useAuthorizationStore } from '@/stores/authorization'
import { useDjangoAuthStore } from '@/stores/authDjango'

const authorizationStore = useAuthorizationStore()
const authStore = useDjangoAuthStore()

const { user } = storeToRefs(authStore)

const canManageGlobalProfiles = computed(() => {
  return authorizationStore.hasServicePermission({
    authSource: 'User',
    allowed: [
      'add_hardwareprofile',
      'change_hardwareprofile',
      'delete_hardwareprofile'
    ]
  })
})

onMounted(async () => {
  await authorizationStore.fetchItems()
  if (user.value?.role) {
    authorizationStore.setCurrentRole([user.value.role])
  }
})
</script>

<template>
  <div class="fill-height">
    <AppBackground>
      <AppSideBar />
      <div class="top-level-content">
        <HardwareProfileManagement
          title="Global Hardware Profiles"
          scope="global"
          :can-manage="canManageGlobalProfiles"
        />
      </div>
    </AppBackground>
  </div>
</template>

<style scoped>
.top-level-content {
  min-height: 100%;
  width: 100%;
  padding: 24px 32px;
}
</style>
